import apiHelpers from './apiHelpers';

export default {
    addIntegrations(body) {
        return apiHelpers.httpRequest('tasks', body, 'post');
    },
    pauseIntegrations(body) {
        return apiHelpers.httpRequest('tasks', body, 'post');
    },
    getIntegrationsState() {
        return apiHelpers.httpRequest('tasks', 'get');
    },
    getAdNetworks() {
        return apiHelpers.httpRequest('adnetworks', {}, 'get');
    },
    currentAdIntegrations(adName) {
        return apiHelpers.httpRequest(`adnetworks/${adName}`, {}, 'get');
    },
    addAdIntegration(code, type) {
        return apiHelpers.httpRequest(`adnetworks/${type}`, {'auth_code': code}, 'post');
    },
    deleteAdNetworkById(type, id) {
        return apiHelpers.httpRequest(`adnetworks/${type}/${id}`, {}, 'delete');
    },

};
